<ng-container *ngrxLet="routeData$ as routeData">
  <div
    class="cg-main-page-container"
    *ngrxLet="{
      isResourcePage: isResourcePage$,
      isLoading: isRouteGuardLoading$,
      isSiteDown: siteDownFlag$,
      pageLayout: pageLayout$,
      pageBg: pageBg$,
    } as check"
  >
    <ng-container *ngIf="check.isSiteDown; else mainPage">
      <cigna-header
        [firstName]="firstName$ | async"
        [lastName]="lastName$ | async"
        [userid]="userid$ | async"
        [profileLinks]="profileNav$ | async"
        [profileNavError]="profileNavError$ | async"
        [isImpersonator]="impersonator$ | async"
        [isNavigationDisabled]="true"
        [isAuthenticated]="true"
        [logoLink]="
          routeData.disableNavigation && !check.isResourcePage
            ? ''
            : (logoLink$ | async)
        "
        [isLogoLinkInternal]="!check.isResourcePage"
        [isResourceResults]="check.isResourcePage"
        [hasMessageCenterFunction]="messageCenterFunction$ | async"
        (logOut)="shellFacade.logOut($event)"
      ></cigna-header>
      <main role="main">
        <cigna-unavailable [shouldShowRefreshBtn]="false"></cigna-unavailable>
      </main>
    </ng-container>
    <ng-template #mainPage>
      <header role="banner">
        <cigna-password-change-banner-v2
          *ngIf="(shouldShowPwBanner$ | async) && !routeData.disableNavigation"
          [passwordExpiry]="passwordExpiry$ | async"
        ></cigna-password-change-banner-v2>

        <cigna-header
          [firstName]="firstName$ | async"
          [lastName]="lastName$ | async"
          [userid]="userid$ | async"
          [profileLinks]="profileNav$ | async"
          [profileNavError]="profileNavError$ | async"
          [isImpersonator]="impersonator$ | async"
          [isNavigationDisabled]="routeData.disableNavigation"
          [isAuthenticated]="true"
          [logoLink]="
            routeData.disableNavigation && !check.isResourcePage
              ? ''
              : (logoLink$ | async)
          "
          [isLogoLinkInternal]="!check.isResourcePage"
          [isResourceResults]="check.isResourcePage"
          [hasMessageCenterFunction]="messageCenterFunction$ | async"
          (logOut)="shellFacade.logOut($event)"
        ></cigna-header>
        <ng-container *ngIf="!routeData.disableNavigation && !check.isLoading">
          <cigna-primary-nav
            class="cg-hide-for-print"
            [links]="siteNav$ | async"
            [isImpersonator]="impersonator$ | async"
            [error]="siteNavError$ | async"
            [hasWamApproval]="hasWamApproval$ | async"
            [isEnhInvUserFlow]="isEnhInvUserFlow$ | async"
          ></cigna-primary-nav>
          <cigna-alerts-v2 [alerts]="secureAlerts"></cigna-alerts-v2>
        </ng-container>
      </header>

      <main
        role="main"
        [class.cg-padding-top-none]="
          (check.pageLayout === 'customFlush' ||
            check.pageLayout === 'customFlushTop') &&
          !check.isLoading
        "
        [class.cg-padding-bottom-none]="
          check.pageLayout === 'customFlush' && !check.isLoading
        "
        [class.page-bg-subtle]="check.pageBg === 'subtle' && !check.isLoading"
        [attr.data-layout]="check.pageLayout"
      >
        <div
          [class.cg-inner-page-wrapper]="
            check.pageLayout === 'default' || check.isLoading
          "
        >
          <ng-container *ngIf="check.isLoading">
            <div class="cg-inner-page-wrapper" style="min-height: 500px">
              <ng-leaf-loading-spinner
                label="Loading..."
                size="large"
                class="loader"
              ></ng-leaf-loading-spinner>
            </div>
          </ng-container>

          <router-outlet></router-outlet>
        </div>
      </main>
    </ng-template>
    <footer role="contentinfo">
      <cigna-footer-global
        [isLoggedIn]="true"
        [isMedical]="isMedicalUser$ | async"
      ></cigna-footer-global>
    </footer>
  </div>

  <aside aria-label="Live chat">
    <div class="chat-bubble-container" data-test-id="image-chat-bubble">
      <cigna-omni-entry></cigna-omni-entry>
    </div>
  </aside>

  <aside aria-label="Timeout modal" *ngIf="inBrowserPlatform">
    <cigna-timeout-popup></cigna-timeout-popup>
  </aside>

  <aside *ngIf="DEV_MODE && isApiMock">
    <cigna-dev-toggle class="cg-hide-for-print"></cigna-dev-toggle>
  </aside>
</ng-container>
